import React from "react"
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from "recharts"
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "src/components/ui/table"
import { CHART_COLORS, LOSS_REASON_LABELS, formatINR } from "../constants"

export function WinLossDonut({ totals }) {
  if (!totals) return null

  const data = [
    { name: "Won", value: totals.won, fill: CHART_COLORS.won },
    { name: "Lost", value: totals.lost, fill: CHART_COLORS.lost },
  ].filter((d) => d.value > 0)

  if (!data.length) return null

  return (
    <div className="rounded-lg border border-slate-200 bg-white p-4">
      <div className="mb-3 text-[13px] font-medium text-slate-700">Win vs Loss</div>
      <ResponsiveContainer width="100%" height={220}>
        <PieChart>
          <Pie data={data} innerRadius={55} outerRadius={85} dataKey="value" nameKey="name">
            {data.map((d, i) => (
              <Cell key={i} fill={d.fill} />
            ))}
          </Pie>
          <Tooltip formatter={(value) => [value, "Deals"]} />
          <Legend verticalAlign="bottom" height={32} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  )
}

export function LossReasonsTable({ reasons = [] }) {
  if (!reasons.length) return null

  return (
    <div className="rounded-lg border border-slate-200 bg-white overflow-hidden">
      <div className="px-4 py-3 text-[13px] font-medium text-slate-700">Loss Reasons</div>
      <Table className="text-[13px]">
        <TableHeader className="bg-slate-50 text-left text-slate-500">
          <TableRow className="hover:bg-transparent">
            <TableHead className="h-9 font-medium text-slate-500">Reason</TableHead>
            <TableHead className="h-9 text-right font-medium text-slate-500">Count</TableHead>
            <TableHead className="h-9 text-right font-medium text-slate-500">Value Lost</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {reasons.map((r) => (
            <TableRow key={r.reason}>
              <TableCell className="py-2.5 text-slate-900">
                {LOSS_REASON_LABELS[r.reason] || r.label}
              </TableCell>
              <TableCell className="py-2.5 text-right">{r.count}</TableCell>
              <TableCell className="py-2.5 text-right">{formatINR(r.value_lost)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
